export default function FooterSection() {
  return (
    <footer className="bg-[#111111] py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pb-8 border-b border-white/10">
          {/* Logo & Name */}
          <div className="flex items-center gap-4">
            <img
              src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/7ec3962db22f8713b333d50e21d708d6.jpeg"
              alt="Repuestos Octavio Ospina Sanchez"
              className="h-14 w-auto object-contain rounded-lg"
            />
            <div>
              <div className="text-white font-black text-base leading-tight">
                Repuestos Octavio<br />Ospina Sanchez
              </div>
              <div className="text-[#E10600] text-xs font-semibold mt-1">Especialistas en Mitsubishi</div>
            </div>
          </div>

          {/* Address & Email */}
          <div className="flex flex-col gap-2">
            <a
              href="https://www.google.com/maps/place/Centro+Comercial+Paseo+Bol%C3%ADvar/@6.241957,-75.5747842,824m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8e44285312e50abf:0x8e44b8b1bcafa929!8m2!3d6.2419517!4d-75.5722093!16s%2Fg%2F1ptw_p42z?entry=ttu&g_ep=EgoyMDI2MDQxMy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-start gap-2 text-white/60 text-sm hover:text-white transition-colors cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-line text-[#E10600]"></i>
              </div>
              <span className="leading-snug">
                Calle 41#51-15, Centro comercial<br />Paseo Bolívar local 232,<br />Barrio La Candelaria
              </span>
            </a>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-[#E10600]"></i>
              </div>
              <a
                href="mailto:repuesoctavio@gmail.com"
                className="hover:text-white transition-colors cursor-pointer"
              >
                repuesoctavio@gmail.com
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/RepuesOctavio"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#E10600] text-white/60 hover:text-white transition-all duration-200 cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://www.instagram.com/repues_octavioospina/"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#E10600] text-white/60 hover:text-white transition-all duration-200 cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
          </div>

          {/* WhatsApp button */}
          <a
            href="https://wa.link/szf6pp"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-[#E10600] hover:bg-red-700 text-white font-bold text-sm px-6 py-3 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Contactar ahora
          </a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6">
          <p className="text-white/30 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Repuestos Octavio Ospina Sanchez. Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Especialistas en repuestos Mitsubishi en Colombia
          </p>
        </div>
      </div>
    </footer>
  );
}
